let offline = false;
const listeners = new Set();

export const getIsOffline = () => offline;

export const setIsOffline = (next) => {
  if (offline === next) return;
  offline = next;
  listeners.forEach((listener) => listener());
};

export const subscribeToConnection = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
